import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {useComponentProps, useEffectItem} from 'helpers/hooks/utils';
import DealflowPieChart from 'components/organisms/Charts/DealflowPieChart/DealflowPieChart';
import {useTable} from 'components/organisms/Providers/TableProvider/TableProvider';
import StyledCollectionEntitiesDealflowBreakdownGraphCard
  from 'components/organisms/Cards/CollectionEntitiesDealflowBreakdownGraphCard/CollectionEntitiesDealflowBreakdownGraphCard.styles';
import {useClientStatisticDealflow} from 'services/client/statistic/statistic.utils';
import Box from 'components/atoms/Layout/Box/Box';
import {P} from 'components/atoms/Text/Typography/Typography';
import {useLinkNavigate} from 'helpers/hooks/links';
import utils from 'helpers/utils';
import SimpleLoader from 'components/molecules/Loaders/SimpleLoader/SimpleLoader';

const CollectionEntitiesDealflowBreakdownGraphCard = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps(props, 'CollectionEntitiesDealflowBreakdownGraphCard');

  const tableProvider = useTable();
  const collection = tableProvider.context?.data;
  const graphState = tableProvider.graphState;
  const [dealflow, setDealflow] = useState(null);

  const navigate = useLinkNavigate();

  const listState = useEffectItem(tableProvider.appliedListState());
  const [dealflowBreakdown, isLoading] = useClientStatisticDealflow(
    collection?.collectionId, listState.search, listState.filter, {
      enabled: collection?.collectionId > 0
    });

  useEffect(() => {
    if (dealflowBreakdown) {
      setDealflow(dealflowBreakdown
        .filter(df => df.id > 0)
        .map(df => ({
          count: df.value,
          label: df.label,
          status: df.id
        })));
    }
  }, [dealflowBreakdown]);

  const handleVisibilityChange = (visibility) => {
    graphState.setGraphSettings((current) => ({
      ...current,
      'dealflowBreakdown': {
        ...current?.['dealflowBreakdown'],
        visibility
      }
    }));
  };

  const handleClick = (e, release, data) => {
    if (data?.id) {
      const prefix = data?.id;
      navigate({
        event: e,
        to: `/collections/${collection.collectionId}/entities?custom=dealflow:${prefix}_-1`,
        keepSearchParams: true
      });
    }
  };

  return <StyledCollectionEntitiesDealflowBreakdownGraphCard ref={ref} {...innerProps}
                                                             title="Deal flow breakdown">
    {(utils.isDefined(dealflow) && dealflow?.length > 0) ?
      <DealflowPieChart dealflow={dealflow}
                        showLegend={true}
                        showNoDealflow={false}
                        orientation="horizontal"
                        isLoading={isLoading}
                        visibility={graphState.graphSettings['dealflowBreakdown']?.visibility}
                        onClick={handleClick}
                        onVisibilityChange={handleVisibilityChange} /> : null}

    {(!utils.isDefined(dealflow) || dealflow?.length === 0) ? (
      (!utils.isDefined(dealflow) || isLoading) ?
        <SimpleLoader className="GraphCard-loader" /> :
        <Box className="GraphCard-empty">
          <P>No deal flow data found</P>
        </Box>
    ) : null}
  </StyledCollectionEntitiesDealflowBreakdownGraphCard>
});

CollectionEntitiesDealflowBreakdownGraphCard.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default CollectionEntitiesDealflowBreakdownGraphCard;
